import { atom, useAtom } from 'jotai';
import type { Dispatch, SetStateAction } from 'react';

export const studioListUpdateTriggerAtom = atom<boolean>(false);

export const useStudioListUpdateTrigger = (): [
  boolean,
  Dispatch<SetStateAction<boolean>>,
] => {
  const [trigger, setTrigger] = useAtom(studioListUpdateTriggerAtom);
  return [trigger, setTrigger];
};
